
import Vue from "vue";
import { Component } from "vue-property-decorator";
import Formatter from "@/mixins/formatterMixin";
import DateFormatter from "@/mixins/dateFormatterMixin";
import Invoice, { InvoiceStatus } from "@/models/subscription/invoice";
import TooltipIcon from "@/components/general/TooltipIcon.vue";
import { getCurrencyDisplayValue } from "@/utils/currencyUtils";

@Component({
  components: { TooltipIcon },
  mixins: [DateFormatter, Formatter],
})
export default class BillingHistory extends Vue {
  // 📦 The invoices for the current user subscription
  private get subscriptionInvoices(): Invoice[] {
    return this.$store.state.payments.subscriptionInvoices;
  }

  // 📦 Billing history table headers
  private billingHistoryHeaders = [
    { text: "Billing Period", value: "periodStart" },
    { text: "Invoice Date", value: "created" },
    { text: "Amount Due", value: "amountDue" },
    { text: "Status", value: "paid" },
    { text: "Invoice", value: "pdf" },
  ];

  // 📦 Pagination options for the billing history table
  private paginationBillingHistory = {
    sortBy: ["periodStart"],
    sortDesc: [true],
    mustSort: true,
    itemsPerPage: 10,
  };

  /**
   * 📺 Return the display amount due for the invoice
   */
  private getInvoiceDisplayAmount(
    amountDue: number,
    totalAmount: number
  ): string {
    if (amountDue > 0 && totalAmount > 0) {
      return getCurrencyDisplayValue(amountDue / 100, false, "€");
    }
    return getCurrencyDisplayValue(0, false, "€");
  }

  /**
   * 🎨 Return the text color based on the invoice's status
   */
  private getInvoiceStatusColor(invoiceStatus: InvoiceStatus): string {
    switch (invoiceStatus) {
      case InvoiceStatus.Rollover:
        return "brown--text";
      case InvoiceStatus.Paid:
        return "green--text";
      case InvoiceStatus.Pending:
        return "red--text";
    }
  }

  /**
   * 📺 Returns the text representing the invoice's status
   */
  private getInvoiceStatusText(invoice: Invoice): string {
    switch (invoice.status) {
      case InvoiceStatus.Rollover:
        return "Rollover (€" + (invoice.total / 100).toFixed(2) + ")";
      case InvoiceStatus.Paid:
        return "Paid";
      case InvoiceStatus.Pending:
        return "Pending";
    }
  }
}
